export default __webpack_public_path__ + "static/media/1fresh-snow.1466e802.png";